define('models/parts/menu/datepicker',[
    'underscore', 'backbone', 'utils', 'moment',
    'services/api',
    // views
    'views/parts/menu/menu-datepicker'
], function(_, Backbone, U, moment, API, VMenuDatePicker) {

    var MDatePicker = Backbone.Model.extend({
        defaults: function() {
            return {
                title: 'Date',
                id: 'datepicker',
                icon: 'sl-icon-calendar',
                itemClass: 'btn-action-date',
                attribute: 'date',
                skipTranslation: true,
                view: VMenuDatePicker,
                content: moment()
            };
        },
    });

    // Return the model for the module
    return MDatePicker;
});

